import LocalPaginated from "@/pagination/paginated";
import EntityType from "@/entities/entity-type";

/**
 * Mock implementation of a EntityTypeService.
 *
 * @remarks It is trying to provide the same interface as the other services that
 * connect to the API.
 */
export default class EntityTypeService {
  entityTypes: EntityType[] = [
    { name: "Institución", id: 1 },
    { name: "Municipio", id: 2 },
    { name: "Junta Comunal", id: 3 },
  ];

  private _mockPagination: LocalPaginated<EntityType>;
  public constructor() {
    this._mockPagination = {
      total: this.entityTypes.length,
      perPage: 15,
      currentPage: 1,
      lastPage: 1,
      pageElements: this.entityTypes,
    };
  }

  public getEntityTypes(): AsyncIterable<LocalPaginated<EntityType>> {
    const ctxEntityTypes = this._mockPagination;
    return {
      [Symbol.asyncIterator](): AsyncIterator<LocalPaginated<EntityType>> & {
        ctxEntityTypes: LocalPaginated<EntityType>;
        done: boolean;
      } {
        return {
          ctxEntityTypes,
          done: false,
          async next() {
            if (!this.done) {
              this.done = true;
              return { done: false, value: this.ctxEntityTypes };
            }
            //	this.ctxEntityTypes.pageElements = [];
            return { done: this.done, value: this.ctxEntityTypes };
          },
        };
      },
    };
  }
}
